angular.module('natgeo').factory('TextCircle', ['DropShadow', 
function TextCircle(DropShadow)
{

	var NAMESPACE = "http://www.w3.org/2000/svg";

	function createSVG(radius, borderWidth, borderColor, backgroundColor, dropshadow) 
	{
		var el = document.createElementNS( NAMESPACE, "circle" );

		// Properties   
		el.setAttribute('cx', borderWidth + radius);
		el.setAttribute('cy', borderWidth + radius);
		el.setAttribute('r', radius);
		el.setAttribute('stroke', borderColor);
		el.setAttribute('stroke-width', borderWidth);
		el.setAttribute('fill', backgroundColor);

		if (dropshadow) 
		{
			DropShadow( el );
		}

		return el;
	}

	return function(element, container)
	{
		// Scale element, making sure any data-rect has been expanded and removed.
		element.scale( container.getScale() );

		// Determine text bubble parameters from element data attributes.
		var scale           = parseFloat( element.data('scale') ) || 1.0;
		var radius  			  = parseFloat( element.data('width') || element.data('height') ) * 0.5;
		var borderWidth     = parseFloat( element.data('borderWidth') ) || 10;
		var borderColor     = element.data('borderColor') || '#339E48';
		var backgroundColor = element.data('backgroundColor') || '#BED509';
		var dropshadow      = element.data('dropshadow') !== 'false';

		// Generate the SVG path element
		function generatePath()
		{
			var containerScale = container.getScale();
			var dimensionScale = scale * containerScale;
			var padding = borderWidth * containerScale * 2;
			
			return $(createSVG(
				radius 			  * dimensionScale - padding,
				borderWidth 	* containerScale,
				borderColor,
				backgroundColor,
				dropshadow
			));
		};

		// When the SVG element is scaled, recreate the path.
		element.on('scaled', function()
		{
			element.empty();
			element.append( generatePath() );
		});

		// Invoked scaled to add the path the SVG element
		element.trigger( 'scaled' );
	};
}]);